export default {
  namespaced: true,
  inventory_project_catalog: {
    menu: "Project Catalog",
    title: "Project",
    project_id: "Project ID",
    test: "Project ID",
    name: "Name",
    created_at: "Created",
    updated_at: "Updated",
  },
};
